import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material"

export const MyTable = ({
  rows,
  columns,
  component,
  onRowClick,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  totalElements,
}) => {
  const MyRow = ({ row }) => {
    return (
      <TableRow
        hover
        onClick={!!onRowClick ? () => onRowClick(row) : undefined}
      >
        {columns.map((col, index) => (
          <TableCell key={index} style={{ width: col.width }} align={col.align}>
            {!!col.render ? col.render({ row, columns }) : row[col.field]}
          </TableCell>
        ))}
      </TableRow>
    )
  }

  return (
    <>
      <TableContainer component={component}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns.map((col, index) => (
                <TableCell key={index} align={col.align}>
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <MyRow key={index} row={row} />
            ))}
          </TableBody>
        </Table>
        {!!totalElements && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={"Filas por página"}
          />
        )}
      </TableContainer>
    </>
  )
}
